module.exports = __webpack_public_path__ + "img/tan02.4d2cdcff.png";